// Coordinates are relative to the displayed, rotated CropBox; DPR is irrelevant.
export function canvasToPdfCoords(canvas, pdf, selection) {
  if (![canvas.width, canvas.height, pdf.width, pdf.height].every(v => Number.isFinite(v) && v > 0) ||
      ![selection.x1, selection.y1, selection.x2, selection.y2].every(Number.isFinite)) throw new Error("Invalid coordinates");
  const clamp = (v, max) => Math.max(0, Math.min(v, max));
  const x = clamp(Math.min(selection.x1, selection.x2), canvas.width);
  const y = clamp(Math.min(selection.y1, selection.y2), canvas.height);
  const right = clamp(Math.max(selection.x1, selection.x2), canvas.width);
  const bottom = clamp(Math.max(selection.y1, selection.y2), canvas.height);
  if (right - x < 3 || bottom - y < 3) throw new Error("Selection too small");
  return {x: x * pdf.width / canvas.width, y: y * pdf.height / canvas.height,
    width: (right-x)*pdf.width/canvas.width, height: (bottom-y)*pdf.height/canvas.height,
    page_width: pdf.width, page_height: pdf.height};
}
